"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane.vue"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _goods_promotion = require("@/api/goods_activity/goods_promotion");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GoodsPromotionCfgPane',
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    fnId: {
      type: [String, Number],
      default: ''
    },
    goodsList: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      form: {
        goodsPromotion: [],
        // 商品列表（包含促销价格）
        menuTypes: [],
        // 点餐类型
        vipMember: true,
        // 是否会员
        disabledCoupon: true,
        // 是否禁用优惠券
        executeDateList: [],
        // 执行日期
        dailyTimeRange: ['00:00:00', '23:59:59'],
        // 每日生效时间
        daysOfWeekList: [],
        // 星期列表
        markForEnable: true,
        // 是否启用
        storeScope: 0,
        // 店铺范围
        relatedStoreIdList: [] // 指定门店ID
      },
      menuTypeList: [],
      // 点餐类型列表
      regionStoreList: [],
      // 门店区域列表
      addGoodsDialogVisible: false,
      // 添加商品对话框显示状态
      goodsSearchKeyword: '',
      // 商品搜索关键词
      searchGoodsList: [],
      // 搜索到的商品列表
      selectedGoods: [] // 选择的商品
    };
  },
  created: function created() {
    this.getMenuType();
    this.queryRegionStoreList();
    if (this.fnId) {
      this.getGoodsPromotionDetail();
    }
  },
  methods: {
    getGoodsPromotionDetail: function getGoodsPromotionDetail() {
      var _this = this;
      (0, _goods_promotion.queryGoodsPromotionDetail)(this.fnId).then(function (res) {
        var data = res.data;
        if (data) {
          _this.form.menuTypes = data.menuTypes || [];
          _this.form.vipMember = data.goodsPromotion.vipMember;
          _this.form.disabledCoupon = data.goodsPromotion.disabledCoupons;
          _this.form.executeDateList = data.executeDateList || [];
          _this.form.dailyTimeRange = data.dailyTimeRange || ['00:00:00', '23:59:59'];
          _this.form.daysOfWeekList = data.daysOfWeekList || [];
          _this.form.markForEnable = data.goodsPromotion.markForEnable;
          _this.form.storeScope = data.goodsPromotion.storeScope;
          _this.form.relatedStoreIdList = data.relatedStoreIdList;
          // 从goodsPromotion中取出促销价格
          var promotionPrice = data.goodsPromotion.activityPrice || null;
          _this.form.activityPrice = promotionPrice;

          // 更新商品列表中的促销价格
          if (_this.goodsList && _this.goodsList.length > 0) {
            _this.goodsList.forEach(function (item) {
              item.activityPrice = promotionPrice;
            });
          }
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      // 构建提交的商品列表，包含促销价格
      this.form.goodsPromotion = this.goodsList.map(function (item) {
        return {
          goodsId: item.goodsFnId,
          activityPrice: item.activityPrice
        };
      });
      (0, _goods_promotion.saveOrUpdateGoodsPromotion)(this.form).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        _this2.$emit('success');
      });
    },
    handleRegionStoreChange: function handleRegionStoreChange(val) {
      for (var i = 0; i < val.length; i++) {
        var storeId = val[i];
        if (!this.form.relatedStoreIdList.includes(storeId)) {
          this.form.relatedStoreIdList.push(storeId);
        }
      }
    },
    getMenuType: function getMenuType() {
      var _this3 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this3.menuTypeList = data.records || [];
        }
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this4 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this4.regionStoreList = data.storeRegions || [];
        }
      });
    },
    // 打开添加商品对话框
    openAddGoodsDialog: function openAddGoodsDialog() {
      this.addGoodsDialogVisible = true;
      this.searchGoodsList = [];
      this.selectedGoods = [];
      this.goodsSearchKeyword = '';
    },
    // 搜索商品
    searchGoods: function searchGoods() {
      var _this5 = this;
      if (!this.goodsSearchKeyword) {
        return;
      }
      (0, _goods_promotion.queryGoodsPromotionPage)({
        goodsPromotionType: 0,
        page: 1,
        limit: 100,
        keywords: this.goodsSearchKeyword
      }).then(function (res) {
        var data = res;
        if (data) {
          // 过滤掉已选择的商品
          _this5.searchGoodsList = data.records.filter(function (item) {
            return !_this5.goodsList.some(function (goods) {
              return goods.goodsFnId === item.goodsFnId;
            });
          });
        }
      });
    },
    // 处理商品选择
    handleGoodsSelectionChange: function handleGoodsSelectionChange(val) {
      this.selectedGoods = val || [];
    },
    // 确认添加商品
    confirmAddGoods: function confirmAddGoods() {
      if (this.selectedGoods.length === 0) {
        this.$message.warning('请选择要添加的商品');
        return;
      }
      // 添加选中的商品到商品列表，并初始化促销价格
      var newGoods = this.selectedGoods.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          activityPrice: null
        });
      });
      this.$set(this, 'goodsList', [].concat((0, _toConsumableArray2.default)(this.goodsList), (0, _toConsumableArray2.default)(newGoods)));
      this.addGoodsDialogVisible = false;
    },
    // 移除商品
    removeGoods: function removeGoods(row) {
      var index = this.goodsList.findIndex(function (item) {
        return item.goodsFnId === row.goodsFnId;
      });
      if (index !== -1) {
        this.goodsList.splice(index, 1);
      }
    }
  }
};